// extracted by mini-css-extract-plugin
export default {"timings":"styles_timings__AJEdJ","isMini":"styles_isMini__dWrPd","audioTitle":"styles_audioTitle__ypeBq","track":"styles_track__iJmLZ"};